import { notificationConstants } from "../../../constants/notificationConstants"

export function setLastNotificationIdentifier(notificationIdentifier) {
    return {
        type: notificationConstants.SET_LAST_IDENTIFIER,
        lastIdentifier: notificationIdentifier,
    }
}

export function clearLastNotificationIdentifier() {
    return { type: notificationConstants.CLEAR_LAST_IDENTIFIER }
}

export function setPendingDeepLink(url) {
    return { type: notificationConstants.SET_PENDING_DEEP_LINK, url }
}

export function clearPendingDeepLink() {
    return { type: notificationConstants.CLEAR_PENDING_DEEP_LINK }
}
